var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationMarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exclamation-mark-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "cls-1",
    d: "M16,1A15,15,0,1,1,1,16,15,15,0,0,1,16,1Zm0,2A13,13,0,1,0,29,16,13,13,0,0,0,16,3Zm0,18a2,2,0,1,1-2,2A2,2,0,0,1,16,21ZM17.5,7l-.36,12h-2.3L14.5,7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkCircle);
export default __webpack_public_path__ + "static/media/exclamation-mark-circle.18de2c86.svg";
export { ForwardRef as ReactComponent };